const WCFJIPTheme = {
  init() {
    this.toggle = document.querySelector('[data-theme-toggle]');
    this.syncToggle();
    this.bind();
  },

  currentTheme() {
    return document.documentElement.dataset.theme || 'light';
  },

  syncToggle() {
    if (!this.toggle) {
      return;
    }
    this.toggle.checked = this.currentTheme() === 'dark';
  },

  bind() {
    if (!this.toggle) {
      return;
    }

    this.toggle.addEventListener('change', event => {
      const theme = event.currentTarget.checked ? 'dark' : 'light';
      document.documentElement.dataset.theme = theme;
      localStorage.setItem('wcfjipTheme', theme);
    });
  },
};

document.addEventListener('DOMContentLoaded', () => WCFJIPTheme.init());
